export default new class CategoryTopBar {
  constructor() {
    this.sButtonOpen = 'category-top-bar__open-list';
    this.sCategoryTopList = 'category-top-bar__list';
    this.sCategoryTopListOpen = 'category-top-bar__list-open';
    this.init();
  }

  init() {
    const btn = document.querySelector(`.${this.sButtonOpen}`);
    $(document)
      .on('click', `.${this.sButtonOpen}`, () => {
        $(`.${this.sCategoryTopList}`).toggleClass(this.sCategoryTopListOpen);
        btn.innerHTML = (btn.innerHTML === 'Показать всё') ? btn.innerHTML = 'Скрыть' : btn.innerHTML = 'Показать всё';
      });
  }
}();
